import $ from 'jquery';

// Qty in cart
$(document).on('click', '.js-button-subscription-disable', function(e) {
  e.preventDefault();
  if (confirm($(this).attr('data-confirm'))) {
    $.post(woocommerce_params.ajax_url, {
      'action': 'disable_auto_renew',
      '_wpnonce': $(this).attr('data-nonce')
    },
    function( response ) {
      var jsonResponse = JSON.parse(response);
      location.reload();
    });
  }
});
